import React, { useState, useEffect } from "react";
import "./DataTable.css";
import NewOrder from "../../../features/order/NewOrder";
import NewMeeting from "../../../features/meeting/NewMeeting";
import { useGetAllEmployeesQuery } from "../../../features/auth/employeeSlice";
import { selectCurrentUser } from "../../../features/auth/authSlice";
import { useSelector } from "react-redux";
import Table from "react-data-table-component";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { format } from "date-fns";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import deleteIcon from "../../../assets/images/Delete_1.svg";
import updateIcon from "../../../assets/images/Update_1.svg";
import closeIcon from "../../../assets/images/close.svg";
import { useDeleteOrderMutation } from "../../../features/order/orderSlice";
import { useDeleteMeetingMutation } from "../../../features/meeting/meetingSlice";
import toast from "react-hot-toast";
import { useGetTeamTargetDataQuery } from "../../dashboard/Diagrams/diagramsSlice";
import { currencyFormatter } from "../../../utils/methods";

const DataTable = ({
  type,
  allData,
  tableHeading,
  newOption,
  handleFilter,
  handleEmployee,
}) => {
  const user = useSelector(selectCurrentUser);

  const { data: employees } = useGetAllEmployeesQuery();

  const [deleteOrder] = useDeleteOrderMutation();
  const [deleteMeeting] = useDeleteMeetingMutation();

  const [employeeId, setEmployeeId] = useState("all");
  const [employeeData, setEmployeedata] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDateRange, setShowDateRange] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [updateRow, setUpdateRow] = useState(null);

  const customStyles = {
    head: {
      style: {},
    },
    rows: {
      style: {
        textAlign: "center", // Center align the content in the rows
      },
    },
    headCells: {
      style: {
        fontSize: "16px",
      },
    },
    cells: {
      style: {
        fontSize: "16px",
      },
    },
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const {
    data: targetsForTheYearData,
    isLoading: targetsForTheYearDataIsLoading,
    error: targetsForTheYearDataError,
  } = useGetTeamTargetDataQuery(
    {
      ...dateRange,
    },
    {
      skip: dateRange.startDate === null && dateRange.endDate === null,
    }
  );

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    if (employees) {
      const data = employees.ids
        .map((id) => {
          return employees.entities[id];
        })
        .filter((emp) => emp.activeStatus != "R");
      setEmployeedata(data);
    }
  }, [employees, user.userID]);

  useEffect(() => {
    setTableData(
      employeeId != "all"
        ? allData.filter((data) => data.employeeId === Number(employeeId))
        : allData
    );
  }, [allData, employeeId, searchQuery]);

  const handleOpenModal = () => {
    setShowModal(true);
    setIsUpdate(false);
    setUpdateRow(null);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsUpdate(false);
    setUpdateRow(null);
  };

  const handleEmployeeSelection = (event) => {
    const selectedUserId = event.target.value;
    setEmployeeId(selectedUserId);

    if (selectedUserId === "all") {
      handleEmployee(
        type === "orders" || type === "meetings" ? "all" : user.userID
      );
    } else {
      const employee = employeeData.find(
        (employee) => employee.employeeId === Number(selectedUserId)
      );
      if (employee) {
        handleEmployee(
          type === "orders" || type === "meetings" ? employee : employee.userId
        );
      }
    }
  };

  const handleDateRangeSelection = (event) => {
    dataSetter(event.target.value);
  };

  const handleDateRangeChange = (value) => {
    if (value) {
      const [startDate, endDate] = value;
      const formattedStartDate = format(startDate, "yyyy-MM-dd").toString();
      const formattedEndDate = format(endDate, "yyyy-MM-dd").toString();
      setDateRange({
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      });

      handleFilter("custom", formattedStartDate, formattedEndDate);
    }
  };

  function dataSetter(value) {
    switch (value) {
      case "today":
        handleFilter("today");
        setShowDateRange(false);
        setDateRange({ startDate: null, endDate: null });
        break;
      case "week":
        handleFilter("week");
        setShowDateRange(false);
        setDateRange({ startDate: null, endDate: null });
        break;
      case "month":
        handleFilter("month");
        setShowDateRange(false);
        setDateRange({ startDate: null, endDate: null });
        break;
      case "custom":
        setShowDateRange(true);
        break;
      default:
    }
  }

  const handleUpdate = (row) => {
    if (newOption === 1) {
      setShowModal(true);
      setIsUpdate(true);
      setUpdateRow(row);
    }

    if (newOption === 2) {
      setShowModal(true);
      setIsUpdate(true);
      setUpdateRow(row);
    }
  };

  const handleDelete = (row) => {
    setDeleteRow(row);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (type === "orders") {
      try {
        await deleteOrder(deleteRow.orderId);
        toast.success("Order Deleted Successfully!");
      } catch (error) {
        toast.error(error.message);
      }
    }

    if (type === "meetings") {
      try {
        await deleteMeeting(deleteRow.meetingId);
        toast.success("Meeting Deleted Successfully!");
      } catch (error) {
        toast.error(error.message);
      }
    }

    setShowDeleteModal(false);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
  };

  const checkEmployee = (empId) => {
    const emp = employeeData?.find(
      (employee) => employee.userId === user.userID
    );
    if (emp && empId !== emp.employeeId) {
      return true;
    } else {
      return false;
    }
  };

  const togglePanel = () => {
    setIsPanelOpen((prev) => !prev);
  };

  return (
    <>
      <div className="row justify-content-between">
        <div className="col-12 col-md">
          <div className="row">
            {newOption !== 0 && (
              <div className="col-12 col-md-auto">
                <button
                  className="btn btn-gradient text-center w-100 addNew-btn"
                  onClick={handleOpenModal}
                >
                  {newOption === 1 ? "+ New Order" : "+ New Meeting"}
                </button>
              </div>
            )}
            {showModal && newOption === 1 && (
              <NewOrder
                show={showModal}
                onClose={handleCloseModal}
                isUpdate={isUpdate}
                updateRow={updateRow}
              />
            )}
            {showModal && newOption === 2 && (
              <NewMeeting
                show={showModal}
                onClose={handleCloseModal}
                isUpdate={isUpdate}
                updateRow={updateRow}
              />
            )}
            <div className="col-12 col-md-4 col-lg-3">
              <div className="form-group select-wrapper">
                <select
                  id="month"
                  className="form-control filter"
                  style={{ appearance: "menulist" }}
                  onChange={handleDateRangeSelection}
                  defaultValue={type === "orders" ? "month" : "today"}
                >
                  <option className="option" value="today">
                    Today
                  </option>
                  <option className="option" value="week">
                    This Week
                  </option>
                  <option className="option" value="month">
                    This Month
                  </option>
                  <option className="option" value="custom">
                    Custom
                  </option>
                </select>
              </div>
            </div>
            {showDateRange && (
              <div className="col-12 col-md-4 col-lg-3">
                <DateRangePicker
                  className="mb-sm-3 custom-date-range-picker"
                  format="dd/MM/yyyy"
                  onChange={handleDateRangeChange}
                  block
                  onClean={() => {
                    setDateRange({ startDate: null, endDate: null });
                  }}
                />
              </div>
            )}
            <div className="col-12 col-md-4 col-lg-3">
              <div className="form-group">
                <select
                  id="employee"
                  className="form-control filter"
                  style={{ appearance: "menulist" }}
                  onChange={handleEmployeeSelection}
                  defaultValue={"all"}
                >
                  <option value="all">All</option>
                  {employeeData.map((employee) => (
                    <option
                      key={employee.employeeId}
                      value={employee.employeeId}
                      selected={
                        (type !== "orders" || type !== "meetings") &&
                        employee.userId === user.userID
                      }
                    >
                      {`${employee.firstName} ${employee.lastName}`}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {type === "orders" &&
              showDateRange &&
              dateRange.startDate !== null &&
              dateRange.endDate !== null && (
                <div className="col-12 col-md-auto">
                  <button
                    className="btn btn-warning w-100 mb-3"
                    onClick={togglePanel}
                  >
                    Show targets
                  </button>
                </div>
              )}
          </div>
        </div>
        <div className="col-12 col-md-3">
          <input
            type="text"
            id="searchBox"
            className="form-control"
            placeholder="Search..."
            onChange={handleSearch}
          />
        </div>
      </div>

      <div className="table-responsive table-container">
        {/* {records.length <= 0 && <LoadingSpinner />} */}
        <Table
          fixedHeaderScrollHeight="calc(100vh - 280px)"
          columns={[
            ...tableHeading,
            type === "orders" || type === "meetings"
              ? {
                  name: "Actions",
                  cell: (row) => (
                    <div
                      className="d-flex justify-content-around"
                      style={{ minWidth: "120px" }}
                    >
                      <button
                        className="btn btn-update"
                        onClick={() => handleUpdate(row)}
                        disabled={checkEmployee(row.employeeId)}
                        title="Update"
                      >
                        <img src={updateIcon} />
                      </button>
                      <button
                        className="btn btn-delete"
                        onClick={() => handleDelete(row)}
                        disabled={checkEmployee(row.employeeId)}
                        title="Delete"
                      >
                        <img src={deleteIcon} />
                      </button>
                    </div>
                  ),
                }
              : "",
          ]}
          data={tableData.filter((data) => {
            const searchQueryLower = searchQuery.toLowerCase();
            if (searchQueryLower.startsWith("£")) {
              // const orderAmount = data.orderAmount.toString().toLowerCase();
              const orderAmount = data.orderAmount.toString();
              const queryAmount = parseFloat(searchQueryLower.slice(1)); // Extract the numeric value from search query
              if (!isNaN(queryAmount)) {
                const valueAmount = parseFloat(
                  orderAmount.replace(/[^0-9.-]+/g, "")
                ); // Extract the numeric value from orderAmount
                if (!isNaN(valueAmount) && valueAmount > queryAmount) {
                  return true;
                }
              }
            } else {
              // Filter based on the search query in any value
              const values = Object.values(data);
              for (let i = 0; i < values.length; i++) {
                if (values[i]) {
                  const value = values[i].toString().toLowerCase();
                  if (value.includes(searchQueryLower)) {
                    return true;
                  }
                }
              }
            }

            return false;
          })}
          customStyles={customStyles}
          fixedHeader
        />
      </div>
      <Modal isOpen={showDeleteModal} toggle={cancelDelete} centered>
        <div className="bg-nav p-2 rounded">
          <div className="header-gradient p-2 child rounded d-flex justify-content-between mb-2">
            <h6 className="modal-title" id="title">
              Delete Alert
            </h6>
            <button
              type="button"
              className="closeBtn"
              aria-label="Close"
              onClick={cancelDelete}
            >
              <img src={closeIcon} style={{ width: "70px" }} alt="" />
            </button>
          </div>
          <div className="bg-white p-2">
            <ModalBody>
              <h5 style={{ color: "#000" }}>
                Are you sure you want to delete this row?
              </h5>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                className="btn-update"
                onClick={cancelDelete}
              >
                Cancel
              </Button>
              <Button
                color="danger"
                className="btn-delete"
                onClick={confirmDelete}
              >
                Delete
              </Button>
            </ModalFooter>
          </div>
        </div>
      </Modal>
      <div>
        <Offcanvas
          isOpen={isPanelOpen}
          direction="end"
          scrollable
          toggle={togglePanel}
        >
          <OffcanvasHeader className={"header-gradient"} toggle={togglePanel}>
            Monthly Targets
          </OffcanvasHeader>
          <OffcanvasBody>
            {targetsForTheYearDataIsLoading && "Loading targets..."}
            {targetsForTheYearDataError && (
              <p>
                {targetsForTheYearDataError?.data?.Message ||
                  "An unexpected error occured while fetching targets...!"}
              </p>
            )}
            <ul className="list-group list-group-flush">
              {targetsForTheYearData && targetsForTheYearData.length > 0
                ? targetsForTheYearData.map((target, index) => (
                    <li
                      className="list-group-item d-flex justify-content-between gap-2"
                      key={`target-${index}`}
                    >
                      <div>
                        <span className="me-4">{target?.year}</span>
                        <span className="text-capitalize">{target?.month}</span>
                      </div>
                      <span>
                        {target?.total && currencyFormatter(target?.total)}
                      </span>
                    </li>
                  ))
                : "No targets to show"}
            </ul>
          </OffcanvasBody>
        </Offcanvas>
      </div>
    </>
  );
};

export default DataTable;
